import React, { useState, useEffect } from 'react';
import styles from './CursorTooltip.scss';
import { connect } from 'react-redux';
import OpenSeadragon from 'openseadragon';

function CursorTooltip({
  canvas_editor: { cursorTooltip, fabricOverlay, viewer },
  plan,
}) {
  const [pos, setPos] = useState({ x: 0, y: 0 });
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!fabricOverlay || !plan) return;

    const canvas = fabricOverlay.fabricCanvas();

    const onMouseMove = (e) => {
      const rect = canvas.upperCanvasEl.parentElement.getBoundingClientRect();

      const rawPointer = canvas.getPointer(e);

      const x = rawPointer.x;
      const y = rawPointer.y;

      if (x < 0 || x > plan.width || y < 0 || y > plan.height) {
        setVisible(false);
        return;
      }

      setVisible(true);

      setPos({
        x: e.clientX - rect.left + 10,
        y: e.clientY - rect.top + 10,
      });
    };

    canvas.upperCanvasEl.addEventListener('mousemove', onMouseMove);

    return () => {
      canvas.upperCanvasEl.removeEventListener('mousemove', onMouseMove);
    };
  }, [fabricOverlay, plan]);

  if (!cursorTooltip || !visible) return null;

  return (
    <div
      className={styles.wrapper}
      style={{
        top: pos.y,
        left: pos.x,
        position: 'absolute',
      }}
    >
      {cursorTooltip}
    </div>
  );
}

const mapStateToProps = (state) => ({
  canvas_editor: state.canvas_editor,
  user_id: state.auth.id,
});

export default connect(mapStateToProps, null)(CursorTooltip);
